.Menu {
  border-radius: 10px;
  border: 1px solid var(--colori-neutri-white);
  background: var(--primary);
  box-shadow: -4px 4px 10px 4px rgba(0, 0, 0, 0.3);
  width: 250px;
  position: absolute;
  top: 60px;
  right: 32px;
  z-index: 9999;
  height: 560px;
  padding: 32px 24px;
}

.TitleMenu {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: var(--colori-neutri-white);
}

.SloganUser {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 8px;
  color: var(--colori-neutri-gray-2);
}

.ListItemMenu {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: var(--font-roboto-slab);
  display: flex;
  align-items: center;
  color: var(--secondary-variant);
  cursor: pointer;
  padding: 8px;
  text-decoration: none;
}

.ListItemMenu:hover {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 100px;
}

.ListItemOptionSelected {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: var(--font-roboto-slab);
  color: var(--colori-neutri-gray-2);
}
